import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TuiAvatar, TuiSkeleton } from '@taiga-ui/kit';
import { InitialsPipe } from '../../../pipes';

@Component({
	standalone: true,
	imports: [TuiAvatar, InitialsPipe, TuiSkeleton],
	selector: 'mar-algolia-user-row',
	templateUrl: 'algolia-user-row.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'flex items-center text-left gap-4 flex-grow-0 flex-shrink-0',
		'[class.h-24]': '!compact()',
		'[class.py-2]': 'compact()',
		'[class.mx-7]': '!compact()',
	},
})
export class AlgoliaUserRowComponent {
	readonly name = input<string>();
	readonly email = input<string>();
	readonly skeleton = input<boolean>();
	readonly compact = input(false);
	readonly size = input<'s' | 'm'>('m');
}
